export const SE360_GET_PHOTOGRAPHERBOOKING_SUCCESS = 'SE360_GET_PHOTOGRAPHERBOOKING_SUCCESS';
export const SAVE_ADDRESS_POINT_LOCATION_FOR_BOOKING_SUCCESS =
    'SAVE_ADDRESS_POINT_LOCATION_FOR_BOOKING_SUCCESS';
export const CLEAR_ADDRESS_POINT_LOCATION_FOR_BOOKING_SUCCESS =
    'CLEAR_ADDRESS_POINT_LOCATION_FOR_BOOKING_SUCCESS';
export const SE360_GET_LOCATIONDATA_SUCCESS = 'SE360_GET_LOCATIONDATA_SUCCESS';
export const SE360_GET_LOCATIONDATA_ERROR = 'SE360_GET_LOCATIONDATA_ERROR';
